import { IState } from '../store';

export const getCommentBlock = (state: IState) => {
  return state.commentsData;
};
